module.exports = __webpack_public_path__ + "img/mouth_female_thick.8d50bd7c.png";